export default function useTracker(user, usersClient, fund) {
    const track = (page) =>{
        if(user){
            usersClient.log({fundId: fund?.id, page})
        }
    }
  return {track, user, fund}
}